import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AlunoFindDialog from '../Aluno/AlunoFindDialog';
import Button from '../UI/Button';
import AlunoProfile from '../Aluno/AlunoProfile';
import AlunoFotoList from './AlunoFotoList';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import Typography from '@mui/material/Typography';
import { findByAlunoCodigo } from './api-aluno-foto';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router';

const useStyles = makeStyles({
    container: {
        backgroundColor: '#fff',
        margin: '5px',
        padding: '10px'
    }
})

const AlunoFotoContainer = () => {
    const classes = useStyles();
    const [aluno, setAluno] = useState(null);
    const [listaAF, setListaAF] = useState([]);
    const [openSearch, setOpenSearch] = useState(false);
    const history = useNavigate();

    useEffect(() => {
        if (aluno) {
            findByAlunoCodigo(aluno.codigo).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setListaAF(data);
                }
            })
        }
    }, [aluno]);

    return (
        <Grid
            className={classes.container}
            container
            direction='column'
            spacing={3}
        >
            <Grid>
                <Typography variant="h6">
                    Aluno Foto
                </Typography>
            </Grid>
            <AlunoFindDialog
                openSearch={openSearch}
                setOpenSearch={setOpenSearch}
                setAluno={setAluno}
            />
            {
                aluno ?
                    <>
                        <AlunoProfile
                            aluno={aluno}
                        />
                        <Grid
                            justifyContent='center'
                            alignContent='center'
                            alignItems='center'
                            size={{
                                xs: 12,
                                sm: 12,
                                md: 6,
                                lg: 4,
                                xl: 4
                            }}>
                            <Button
                                onClick={() => setAluno(null)}
                            >
                                Trocar Aluno
                            </Button>
                        </Grid>
                        <AlunoFotoList
                            listaAF={listaAF}
                        />
                    </> :
                    <Grid container direction='row'>
                        <Grid
                            justifyContent='center'
                            alignContent='center'
                            alignItems='center'
                            size={{
                                xs: 12,
                                sm: 12,
                                md: 6,
                                lg: 4,
                                xl: 4
                            }}>
                            <Button
                                onClick={() => setOpenSearch(true)}
                            >
                                Selecionar Aluno
                            </Button>
                        </Grid>
                        <Grid
                            justifyContent='center'
                            alignContent='center'
                            alignItems='center'
                            size={{
                                xs: 12,
                                sm: 12,
                                md: 6,
                                lg: 4,
                                xl: 4
                            }}>
                            <Button
                                onClick={() => history("/aluno-foto-insert")}
                            >
                                Inserir por Ano Letivo
                            </Button>
                        </Grid>
                    </Grid>
            }
        </Grid >
    );
}

export default AlunoFotoContainer;